import { main_url } from "../pages/basefile";
import { getValidToken } from "../auth/getToken";

async function getAuthHeaders() {
  const token = (await getValidToken()) || localStorage.getItem("authToken");
  if (!token) {
    throw new Error("Authentication required. Redirecting to login.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export async function fetchKeycloakUsersDropdown({ search = "", limit = 200 } = {}) {
  const params = new URLSearchParams({
    search,
    limit: String(limit),
  });
  const response = await fetch(`${main_url}/api/v1/keycloak-users/dropdown?${params.toString()}`, {
    method: "GET",
    headers: await getAuthHeaders(),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Failed to fetch realm users");
  }

  return response.json();
}
